import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { PriceComponent } from './price.component';
import { InputDebounceComponent } from './input-debounce.component';
import { DateComponent } from './date.component';
import { DialogComponent } from './dialog.component';
import { VariantHistoryComponent } from './variant-history.component';
import { AvatarComponent } from './avatar.component';
import { ImageComponent } from './image.component';
import { ReportButtonComponent } from './reportButton.component';


import { ProductExcelComponent } from './evs/product/product.excel.component';
import { StoreExcelComponent } from './evs/store/store.excel.component';

import { ModalModule } from 'ngx-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GrowlModule } from 'primeng/primeng';

import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, RouterModule, ModalModule.forRoot(), FormsModule, ReactiveFormsModule, GrowlModule, TranslateModule.forChild()],
  declarations: [PriceComponent, DateComponent, DialogComponent, VariantHistoryComponent,
    AvatarComponent, ImageComponent, ReportButtonComponent,
    InputDebounceComponent, ProductExcelComponent, StoreExcelComponent],
  exports: [PriceComponent, DateComponent, DialogComponent, VariantHistoryComponent, AvatarComponent, ImageComponent,
    ReportButtonComponent,
    InputDebounceComponent],
  providers: []
})
export class HelperModule {
}



// WEBPACK FOOTER //
// /app/src/app/common/helper/helper.module.ts